import React from "react";
import "@/styles/scss/components/_app-header.scss";

const AppHeader = () => {
  return (
    <div className="application-header">
      <div className="row">
        <div className="col">
          <div className="p-3">
            <div className="fw-medium h6 mb-0">Andrew Allen</div>
            <div className="email">
              <i className="bi bi-envelope  me-1" />
              <a href="mailto:andrew.allen@approveshield.com">
                andrew.allen@approveshield.com
              </a>
            </div>
            <div className="phone">
              <i className="bi bi-phone me-1" />
              <span>469-555-5555</span>
            </div>
          </div>
        </div>
        <div className="col">
          <div className="float-end p-3">
            <button className="btn btn-icon btn-danger-transparent rounded-pill btn-wave mx-1">
              <i className="bi bi-calendar-plus" />
            </button>
            <button className="btn btn-icon btn-danger-transparent rounded-pill btn-wave mx-1">
              <i className="bi bi-chat" />
            </button>
            <button className="btn btn-icon btn-danger-transparent rounded-pill btn-wave mx-1">
              <i className="bi bi-sticky" />
            </button>
          </div>
        </div>
      </div>
      <div className="body container">
        <div className="row">
          <div className="col ps-1">
            <div className="p-3">
              <label>Screening Type</label>
              <div className="fw-medium">Standard</div>
            </div>
          </div>

          <div className="col ps-1">
            <div className="p-3">
              <label>SSN/Name Match</label>
              <div className="fw-medium">YES</div>
            </div>
          </div>

          <div className="col ps-1">
            <div className="p-3">
              <label>Assignee</label>
              <div className="fw-medium">Ellen Waite</div>
            </div>
          </div>
          <div className="col ps-1">
            <div className="p-3">
              <label>Age</label>
              <div className="fw-medium">6 days</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

AppHeader.propTypes = {};

export default AppHeader;
